const pages = "/auth/"

export const UPDATE_AUTH_DATA = `${pages}UPDATE_AUTH_DATA`;
export const RESET = `${pages}RESET`;
export const UPDATE_REDUCER = `${pages}UPDATE_REDUCER`;
// Set once the stored session has been read, so the router can tell
// "not logged in" apart from "not checked yet" and avoid a false redirect.
export const AUTH_CHECKED = `${pages}AUTH_CHECKED`;

